export default "https://cdn.questicon.mathletics.com/assets/images/Star-grey-ec4f0859d0f34adb253b0a769c682975.svg";